import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";
import { ChatCircleDots, ArrowRight } from "@phosphor-icons/react";

export default function NewEnquiry() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: user?.name || "",
    phone: user?.phone || "",
    email: user?.email || "",
    service: "",
    message: "",
    source: "website",
    status: "new",
  });
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/portal/enquiries", form);
      toast.success("Consultation requested. We'll be in touch shortly.");
      navigate("/portal");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="new-enquiry-page" className="max-w-2xl">
      <div className="flex items-center gap-3 mb-2">
        <ChatCircleDots size={28} weight="duotone" color="#E60000"/>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tighter" style={{fontFamily:"Manrope, sans-serif"}}>Request a consultation</h1>
      </div>
      <p className="text-sm text-zinc-500 mb-8">Tell us what brings you to Dr Tayyeb&apos;s. Our team will respond shortly.</p>

      <form onSubmit={save} className="bg-white border border-zinc-200 rounded-sm p-6 space-y-4" data-testid="enquiry-form">
        <F label="Name"><input required value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} className={inp} data-testid="pne-name"/></F>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <F label="Phone"><input required value={form.phone} onChange={(e)=>setForm({...form,phone:e.target.value})} className={inp} data-testid="pne-phone"/></F>
          <F label="Email"><input type="email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} className={inp} data-testid="pne-email"/></F>
        </div>
        <F label="What treatment / concern?">
          <input value={form.service} onChange={(e)=>setForm({...form,service:e.target.value})}
            placeholder="e.g. Toothache, Implant consultation, Orthodonticsâ€¦" className={inp} data-testid="pne-service"/>
        </F>
        <F label="Message">
          <textarea rows={4} value={form.message} onChange={(e)=>setForm({...form,message:e.target.value})}
            placeholder="Describe your symptoms or preferred timeâ€¦" className={inp} data-testid="pne-message"/>
        </F>
        <button type="submit" disabled={busy}
          className="inline-flex items-center gap-2 bg-[#E60000] hover:bg-[#CC0000] text-white font-semibold rounded-sm px-6 py-3 text-sm disabled:opacity-60"
          data-testid="pne-submit">
          {busy ? "Sendingâ€¦" : "Send request"} <ArrowRight size={14} weight="bold"/>
        </button>
      </form>
    </div>
  );
}

const inp = "w-full border border-zinc-300 rounded-sm px-3 py-2.5 focus:outline-none focus:border-zinc-900";
function F({ label, children }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-700">{label}</label>
      <div className="mt-2">{children}</div>
    </div>
  );
}
